var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _resolveNextPagePromise, _resolvePreviousPagePromise, _aspectRatioHelper, _PaginatedList_instances, observeViewMore_fn, shouldUsePage_fn, fetchPage_fn, fetchSpecificPage_fn, renderNextPage_fn, renderPreviousPage_fn, getPage_fn, getGridForPage_fn, _handleFilterUpdate;
import { Component } from "@theme/component";
import { sectionRenderer } from "@theme/section-renderer";
import { requestIdleCallback, viewTransition } from "@theme/utilities";
import { ThemeEvents } from "@theme/events";
import { PaginatedListAspectRatioHelper } from "@theme/paginated-list-aspect-ratio";
class PaginatedList extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _PaginatedList_instances);
    /**
     * @type {Map<number, string>}
     */
    __publicField(this, "pages", /* @__PURE__ */ new Map());
    /** @type {IntersectionObserver | undefined} */
    __publicField(this, "infinityScrollObserver");
    /** @type {((value: void) => void) | null} */
    __privateAdd(this, _resolveNextPagePromise, null);
    /** @type {((value: void) => void) | null} */
    __privateAdd(this, _resolvePreviousPagePromise, null);
    /** @type {PaginatedListAspectRatioHelper} */
    __privateAdd(this, _aspectRatioHelper);
    /**
     * Handle filter updates by clearing cached pages
     */
    __privateAdd(this, _handleFilterUpdate, () => {
      var _a, _b;
      this.pages.clear();
      (_a = __privateGet(this, _resolveNextPagePromise)) == null ? void 0 : _a.call(this);
      (_b = __privateGet(this, _resolvePreviousPagePromise)) == null ? void 0 : _b.call(this);
      __privateSet(this, _resolveNextPagePromise, null);
      __privateSet(this, _resolvePreviousPagePromise, null);
      const currentLastPage = this.refs.grid?.dataset.lastPage;
      const observer = new MutationObserver(() => {
        const newLastPage = this.refs.grid?.dataset.lastPage;
        if (newLastPage !== currentLastPage) {
          observer.disconnect();
          if (!this.isConnected) {
            return;
          }
          __privateMethod(this, _PaginatedList_instances, observeViewMore_fn).call(this);
          __privateMethod(this, _PaginatedList_instances, fetchPage_fn).call(this, "next");
        }
      });
      const { grid } = this.refs;
      if (grid) {
        observer.observe(grid, {
          attributes: true,
          attributeFilter: ["data-last-page"],
          childList: true
          // Also watch for child changes in case the whole grid is replaced
        });
        setTimeout(() => {
          if (observer) {
            observer.disconnect();
          }
        }, 3e3);
      }
    });
  }
  connectedCallback() {
    super.connectedCallback();
    const templateCard = this.querySelector('[ref="cardGallery"]');
    if (templateCard) {
      __privateSet(this, _aspectRatioHelper, new PaginatedListAspectRatioHelper({
        templateCard
      }));
    }
    __privateMethod(this, _PaginatedList_instances, fetchPage_fn).call(this, "next");
    __privateMethod(this, _PaginatedList_instances, fetchPage_fn).call(this, "previous");
    __privateMethod(this, _PaginatedList_instances, observeViewMore_fn).call(this);
    document.addEventListener(ThemeEvents.FilterUpdate, __privateGet(this, _handleFilterUpdate));
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.infinityScrollObserver) {
      this.infinityScrollObserver.disconnect();
    }
    document.removeEventListener(ThemeEvents.FilterUpdate, __privateGet(this, _handleFilterUpdate));
  }
  get sectionId() {
    const id = this.getAttribute("section-id");
    if (!id) throw new Error("The section-id attribute is required");
    return id;
  }
}
_resolveNextPagePromise = new WeakMap();
_resolvePreviousPagePromise = new WeakMap();
_aspectRatioHelper = new WeakMap();
_PaginatedList_instances = new WeakSet();
observeViewMore_fn = function() {
  const { viewMorePrevious, viewMoreNext } = this.refs;
  if (!viewMorePrevious && !viewMoreNext) return;
  if (!this.infinityScrollObserver) {
    this.infinityScrollObserver = new IntersectionObserver(
      async (entries) => {
        if (viewTransition.current) await viewTransition.current;
        for (const entry of entries) {
          if (entry.isIntersecting) {
            const { viewMorePrevious: viewMorePrevious2, viewMoreNext: viewMoreNext2 } = this.refs;
            if (entry.target === viewMorePrevious2) {
              __privateMethod(this, _PaginatedList_instances, renderPreviousPage_fn).call(this);
            } else if (entry.target === viewMoreNext2) {
              __privateMethod(this, _PaginatedList_instances, renderNextPage_fn).call(this);
            }
          }
        }
      },
      {
        rootMargin: "100px"
      }
    );
  }
  if (viewMorePrevious) {
    this.infinityScrollObserver.observe(viewMorePrevious);
  }
  if (viewMoreNext) {
    this.infinityScrollObserver.observe(viewMoreNext);
  }
};
/**
 * @param {{ page: number, url?: URL } | undefined} pageInfo - The page info
 * @returns {boolean} Whether to use the page
 */
shouldUsePage_fn = function(pageInfo) {
  if (!pageInfo) return false;
  const { grid } = this.refs;
  const lastPage = grid?.dataset.lastPage;
  if (!lastPage || pageInfo.page < 1 || pageInfo.page > Number(lastPage)) return false;
  return true;
};
fetchPage_fn = async function(type) {
  const page = __privateMethod(this, _PaginatedList_instances, getPage_fn).call(this, type);
  const resolvePromise = () => {
    var _a, _b;
    if (type === "next") {
      (_a = __privateGet(this, _resolveNextPagePromise)) == null ? void 0 : _a.call(this);
      __privateSet(this, _resolveNextPagePromise, null);
    } else {
      (_b = __privateGet(this, _resolvePreviousPagePromise)) == null ? void 0 : _b.call(this);
      __privateSet(this, _resolvePreviousPagePromise, null);
    }
  };
  if (!page || !__privateMethod(this, _PaginatedList_instances, shouldUsePage_fn).call(this, page)) {
    resolvePromise();
    return;
  }
  await __privateMethod(this, _PaginatedList_instances, fetchSpecificPage_fn).call(this, page.page, page.url);
  resolvePromise();
};
fetchSpecificPage_fn = async function(pageNumber, url = void 0) {
  const pageInfo = { page: pageNumber, url };
  if (!url) {
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set("page", pageNumber.toString());
    newUrl.hash = "";
    pageInfo.url = newUrl;
  }
  if (!__privateMethod(this, _PaginatedList_instances, shouldUsePage_fn).call(this, pageInfo)) return;
  const pageContent = await sectionRenderer.getSectionHTML(this.sectionId, true, pageInfo.url);
  this.pages.set(pageNumber, pageContent);
};
renderNextPage_fn = async function() {
  const { grid } = this.refs;
  if (!grid) return;
  const nextPage = __privateMethod(this, _PaginatedList_instances, getPage_fn).call(this, "next");
  if (!nextPage || !__privateMethod(this, _PaginatedList_instances, shouldUsePage_fn).call(this, nextPage)) return;
  let nextPageItemElements = __privateMethod(this, _PaginatedList_instances, getGridForPage_fn).call(this, nextPage.page);
  if (!nextPageItemElements) {
    const promise = new Promise((res) => {
      __privateSet(this, _resolveNextPagePromise, res);
    });
    __privateMethod(this, _PaginatedList_instances, fetchPage_fn).call(this, "next");
    await promise;
    nextPageItemElements = __privateMethod(this, _PaginatedList_instances, getGridForPage_fn).call(this, nextPage.page);
    if (!nextPageItemElements) return;
  }
  grid.append(...nextPageItemElements);
  __privateGet(this, _aspectRatioHelper).processNewElements();
  history.pushState("", "", nextPage.url.toString());
  requestIdleCallback(() => {
    __privateMethod(this, _PaginatedList_instances, fetchPage_fn).call(this, "next");
  });
};
renderPreviousPage_fn = async function() {
  const { grid } = this.refs;
  if (!grid) return;
  const previousPage = __privateMethod(this, _PaginatedList_instances, getPage_fn).call(this, "previous");
  if (!previousPage || !__privateMethod(this, _PaginatedList_instances, shouldUsePage_fn).call(this, previousPage)) return;
  let previousPageItemElements = __privateMethod(this, _PaginatedList_instances, getGridForPage_fn).call(this, previousPage.page);
  if (!previousPageItemElements) {
    const promise = new Promise((res) => {
      __privateSet(this, _resolvePreviousPagePromise, res);
    });
    __privateMethod(this, _PaginatedList_instances, fetchPage_fn).call(this, "previous");
    await promise;
    previousPageItemElements = __privateMethod(this, _PaginatedList_instances, getGridForPage_fn).call(this, previousPage.page);
    if (!previousPageItemElements) return;
  }
  const scrollTop = window.scrollY;
  const firstElement = grid.firstElementChild;
  const oldHeight = firstElement ? firstElement.getBoundingClientRect().top + window.scrollY : 0;
  grid.prepend(...previousPageItemElements);
  __privateGet(this, _aspectRatioHelper).processNewElements();
  history.pushState("", "", previousPage.url.toString());
  if (firstElement) {
    const newHeight = firstElement.getBoundingClientRect().top + window.scrollY;
    const heightDiff = newHeight - oldHeight;
    window.scrollTo({
      top: scrollTop + heightDiff,
      behavior: "instant"
    });
  }
  requestIdleCallback(() => {
    __privateMethod(this, _PaginatedList_instances, fetchPage_fn).call(this, "previous");
  });
};
/**
 * @param {"previous" | "next"} type
 * @returns {{ page: number, url: URL } | undefined}
 */
getPage_fn = function(type) {
  const { cards } = this.refs;
  const isPrevious = type === "previous";
  if (!Array.isArray(cards)) return;
  const targetCard = cards[isPrevious ? 0 : cards.length - 1];
  if (!targetCard) return;
  const currentCardPage = Number(targetCard.dataset.page);
  const page = isPrevious ? currentCardPage - 1 : currentCardPage + 1;
  const url = new URL(window.location.href);
  url.searchParams.set("page", page.toString());
  url.hash = "";
  return {
    page,
    url
  };
};
/**
 * @param {number} page
 * @returns {NodeListOf<Element> | undefined}
 */
getGridForPage_fn = function(page) {
  const pageHTML = this.pages.get(page);
  if (!pageHTML) return;
  const parsedPage = new DOMParser().parseFromString(pageHTML, "text/html");
  const gridElement = parsedPage.querySelector('[ref="grid"]');
  if (!gridElement) return;
  return gridElement.querySelectorAll(':scope > [ref="cards[]"]');
};
_handleFilterUpdate = new WeakMap();
export {
  PaginatedList as default
};
